import { Base64 } from './base64';

export const createBlob = (base64: Base64, type: string): Blob => {
   const binary = atob(base64.replace(/\s/gu, ''));
   const len = binary.length;
   const buffer = new ArrayBuffer(len);
   const view = new Uint8Array(buffer);
   for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
   }

   return new Blob([view], { type: type });
};
